import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {useNavigationBlocking} from '../../../../../srcCommon/app/navigationBlocking';

/*
 * Props.
 */

interface CommentComposerUnsavedEditDialogProps {
  panelId: ViewerPanelId;
  shouldBlockNavigation?: boolean;
}

/*
 * Component.
 */

export const CommentComposerUnsavedEditDialog: FC<CommentComposerUnsavedEditDialogProps> = (props) => {
  const {panelId, shouldBlockNavigation} = props;

  const {didBlockNavigation, cancelNavigation, unblockNavigation} = useNavigationBlocking(
    panelId,
    Boolean(shouldBlockNavigation),
  );
  return (
    <>
      {didBlockNavigation && (
        <OkCancelDialog
          title={<Trans id="comment-composer-unsaved-edit-dialog-title">Unsaved changes</Trans>}
          okButtonLabel={<Trans id="comment-composer-unsaved-edit-dialog-ok-button">Discard</Trans>}
          okButtonVariant={ButtonVariantsEnum.DANGER}
          onRequestClose={cancelNavigation}
          onOkClick={unblockNavigation}
        >
          <Trans id="comment-composer-unsaved-edit-dialog-message">
            You have unsaved changes. Do you want to discard your changes?
          </Trans>
        </OkCancelDialog>
      )}
    </>
  );
};
